import { render, staticRenderFns } from "./apex-table.vue?vue&type=template&id=47b11b5c&scoped=true"
import script from "./apex-table.vue?vue&type=script&lang=js"
export * from "./apex-table.vue?vue&type=script&lang=js"
import style0 from "./apex-table.vue?vue&type=style&index=0&id=47b11b5c&prod&lang=css"
import style1 from "./apex-table.vue?vue&type=style&index=1&id=47b11b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b11b5c",
  null
  
)

export default component.exports